import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../services/authService';

interface GetExchangeRatesParams {
  source_currency_code?: string;
  dest_currency_code?: string;
}

const useGetExchangeRates = (params: GetExchangeRatesParams = {}) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
    isError,
    refetch,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['exchange-rates', params],
    queryFn: async ({ pageParam = '' }) => {
      let url = '/admin/rates';
      const searchParams = new URLSearchParams();
      if (params.source_currency_code) searchParams.append('source_currency_code', params.source_currency_code);
      if (params.dest_currency_code) searchParams.append('dest_currency_code', params.dest_currency_code);
      if (pageParam) searchParams.append('next_cursor', pageParam);
      if (searchParams.toString()) url += `?${searchParams.toString()}`;
      
      const response = await api.get(url);
      return {
        rates: response.data.rates || [],
        next_cursor: response.data.next_cursor,
      };
    },
    getNextPageParam: (lastPage) => lastPage?.next_cursor,
    initialPageParam: '',
    select: (data) => ({
      rates: data?.pages.flatMap((page) => page?.rates) || [],
      next_cursor: data?.pages[data.pages.length - 1]?.next_cursor,
    }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data: data?.rates || [],
    nextCursor: data?.next_cursor,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading: isFetching,
    status,
    isError,
    refetch,
    isPending,
  };
};

export default useGetExchangeRates; 